/**
 * 商品検索用VOクラス
 *
 * @export CandidateGoodsSearchConditionModel
 * @class CandidateGoodsSearchConditionModel
 */
export class CandidateGoodsSearchConditionModel {

  /** Pコード */
  public pcode: string = <string>'';
  /** アイテムコード */
  public itemCode: string = <string>'';
  /** JANコード */
  public janCode: string = <string>'';
  /** メーカ名 */
  public makerName: string = <string>'';
  /** 商品案内用商品名 */
  public guideGoodsNameList: Array<string> = new Array<string>();
  /** 商品案内用規格名 */
  public guideStandardNameList: Array<string> = new Array<string>();
  /** タグ検索方法 */
  public tagSearchType: string = <string>'';
  /** タグリスト */
  public tagIdList: Array<string> = new Array<string>();
  /** 商品マーク検索方法 */
  public goodsMarkSearchType: string = <string>'';
  /** 商品マークコードリスト */
  public goodsMarkCodeList: Array<string> = new Array<string>();
  /** 取扱終了商品を含む */
  public dataKbnFlg = false;
  /** 商品区分 */
  public goodsDiv: string = <string>'';
  /** 生協コードリスト */
  public coopCodeList: Array<string> = new Array<string>();
  /** バイヤーコード */
  public buyerCode: string = <string>'';
  /** 登録レベル */
  public admitStatus: string = <string>'';
  /** 商品マスタ登録日From */
  public registDateFrom: string = <string>'';
  /** 商品マスタ登録日To */
  public registDateTo: string = <string>'';
  /** 商品マスタ更新日From */
  public updateDateFrom: string = <string>'';
  /** 商品マスタ更新日To */
  public updateDateTo: string = <string>'';
  /** 部門コード */
  public classCode: string = <string>'';
  /** 中分類コード */
  public middleClassCode: string = <string>'';
  /** 小分類コード */
  public smallClassCode: string = <string>'';
  /** 発注先コード */
  public ordrClientCode: string = <string>'';
  /** 発注先名称 */
  public ordrClientKanji: string = <string>'';
  /** 支払先コード */
  public payeeClientCode: string = <string>'';
  /** 支払先名称 */
  public payeeClientKanji: string = <string>'';
  /** デイリーリスト */
  public dutiesList: Array<string> = new Array<string>();
  /** Ｐコードリスト */
  public pcodeList: Array<string> = new Array<string>();
  /** アイテムコードリスト */
  public itemCodeList: Array<string> = new Array<string>();

  /** ページ番号 */
  public pageNo: number = <number>0;
  /** ソートキー */
  public sortKey: string = <string>'';
  /** 降順または昇順 */
  public orderKey: string = <string>'';
  /** 商品情報出力先区分(0:候補リスト画面、1:商品マスタ画面) */
  public goodsInfoOutDiv: string = <string>'0';

  /**
    * コンストラクタ
    */
  public CandidateGoodsSearchConditionVO() { }

}
